//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      showImg: false,
      scroll: ''
    };
  },
  watch: {
    scroll: function() {
      this.$nextTick(() => {
         var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
        console.log('赋值前------'+scrollTop)
        // document.getElementById('home').scrollHeight;
        // let boxHeight = document.documentElement.scrollHeight || document.body.scrollHeight 
         if(scrollTop != document.body.scrollHeight){
             scrollTop = document.body.scrollHeight;
             document.documentElement.scrollTop = scrollTop;
         }
        console.log('赋值后------'+scrollTop)
        console.log(document.body.scrollHeight)
      });
    }
  },
  methods: {
    sky() {
       this.showImg = true;
       this.scroll = '1';
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/repairComponents/imgDome.vue